module.exports = __webpack_public_path__ + "static/media/NEW-FONDOS_5.307366c4.svg";